const roles = [
  "Software Engineer",
  "Full-Stack Developer",
  "Java Developer",
  "Backend Developer",
  "DevOps Engineer",
];

export default roles;
